import accountSettingsModule from '../accountSettingsModule';

function notificationConstantsService($log, languageResource) {
  'ngInject';

  const ls = languageResource;
  return {
    notificationSourceTypeMapping: {
      FriendRequestReceived: ls.get('Label.Notifications.FriendRequestReceived'),
      FriendRequestAccepted: ls.get('Label.Notifications.FriendRequestAccepted'),
      PartyInviteReceived: ls.get('Label.Notifications.PartyInvited'),
      PartyMemberJoined: ls.get('Label.Notifications.PartyJoined'),
      ChatNewMessage: ls.get('Label.Notifications.Chat'),
      PrivateMessageReceived: ls.get('Label.Notifications.PrivateMessage'),
      UserAddedToPrivateServerWhiteList: ls.get('Label.Notifications.AddedToServer'),
      ConversationUniverseChanged: ls.get('Label.Notifications.ConversationUniverseChanged'),
      TeamCreateInvite: ls.get('Label.Notifications.TeamCreateInvite'),
      GameUpdate: ls.get('Label.Notifications.GameUpdate'),
      DeveloperMetricsAvailable: ls.get('Label.Notifications.DeveloperMetricsAvailable')
    },
    destinationTypes: ['NotificationStream', 'DesktopPush', 'MobilePush'],
    modalText: {
      success: {
        title: ls.get('Heading.Dialog.DefaultSuccess'),
        body: ls.get('Response.Dialog.DefaultSuccessMessage')
      },
      error: {
        title: ls.get('Heading.Dialog.DefaultError'),
        body: ls.get('Response.Dialog.UpdateNotificationSettingsError')
      }
    },
    receiverDestinationTypeMapping: [
      {
        destinationType: 'NotificationStream',
        friendlyTitle: ls.get('Heading.Notifications.Stream'),
        blurbText: ls.get('Description.NotificationStream1'),
        actionWhenText: ls.get('Heading.Notifications.ActionWhen'),
        actionDescriptionText: ls.get('Description.NotificationStream2'),
        areSourcesShown: true,
        isToggleable() {
          return false;
        }
      },
      {
        destinationType: 'DesktopPush',
        friendlyTitle: ls.get('Heading.Notifications.DesktopPush'),
        blurbText: ls.get('Description.DesktopPush1'),
        secondaryBlurbText: ls.get('Description.DesktopPush2'),
        actionWhenText: ls.get('Heading.Notifications.ActionWhen'),
        actionDescriptionText: ls.get('Description.DesktopPush3')
      },
      {
        destinationType: 'MobilePush',
        friendlyTitle: ls.get('Heading.Notifications.MobilePush'),
        blurbText: ls.get('Description.MobilePush1'),
        actionWhenText: '',
        areSourcesShown: true,
        actionDescriptionText: ls.get('Description.MobilePush2')
      }
    ]
  };
}

accountSettingsModule.factory('notificationConstantsService', notificationConstantsService);

export default notificationConstantsService;
